import { buttonProcessGet, globalSettings, isUndNullEmp, processEvaluateGet, responseGet } from '../../helpers/settings'
import { supplierModelGet } from '../../models/expenses/suppliers';

export const supplierProcessButtonsGetAsync = async ({
    supplier = supplierModelGet({}),
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'supplierProcessButtonsGetAsync';
    let response = responseGet();
    try {
        //#region buttons set
        const processButton = [{
            isVisible: true,
            showDivider: true,
            isEnabled: true,
            methodName: 'balance',
            icon: globalSettings?.icons?.moneyBillWave,
            label: globalSettings?.labels?.balance?.[languageId],
        },];
        //#endregion buttons set

        //#region data get
        const dataObj = [
            supplier?.description,
            supplier?.rif,
            !isUndNullEmp({ data: supplier?.national, subMethod: currentMethod, })?.result ?
                supplier?.national ?
                    globalSettings?.labels?.national :
                    globalSettings?.labels?.international :
                globalSettings?.labels?.national,
            buttonProcessGet({
                id: supplier?.id,
                description: supplier?.description,
                showDetails: true,
                labelDetails: globalSettings?.labels?.detail?.[languageId],
                enabledDetails: true,
                showEdit: true,
                labelEdit: globalSettings?.labels?.edit?.[languageId],
                enabledEdit: processEvaluateGet({
                    object: supplier,
                    property: globalSettings?.labels?.process?.en?.toLowerCase(),
                    process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result,
                showDelete: true,
                labelDelete: globalSettings?.labels?.delete?.[languageId],
                //enabledDelete: processEvaluateGet(supplier, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.delete?.en?.toLowerCase(), currentMethod).result,
                enabledDelete: processEvaluateGet({
                    object: supplier,
                    property: globalSettings?.labels?.process?.en?.toLowerCase(),
                    process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result,
                processButtons: processButton,
                subMethod: currentMethod,
            })?.result,
        ]
        //#endregion data get

        //#region final data set
        response.result = dataObj;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
        response.result = [];
    }
    return response;
}

// export const localProcessButtonGetAsync = async (supplier = {}, languageId = 'es', subMethod = '',) => {
//     let response = responseGet();
//     try {
//         //#region buttons set

//         const processButton = [{
//             isVisible: true,
//             showDivider: true,
//             isEnabled: true,
//             methodName: 'balance',
//             icon: globalSettings?.icons?.moneyBillWave,
//             label: globalSettings?.labels?.balance?.[languageId],
//         },];

//         //#endregion buttons set

//         //#region data get

//         const localData = [
//             supplier?.description,
//             supplier?.rif,
//             !isUndefined(supplier?.national) ?
//                 (supplier?.national ?
//                     globalSettings?.labels?.national : globalSettings?.labels?.international) : globalSettings?.labels?.national,
//             buttonProcessGet(
//                 supplier?.id,
//                 supplier?.description,
//                 true,
//                 globalSettings?.labels?.detail?.[languageId],
//                 true,
//                 true,
//                 globalSettings?.labels?.edit?.[languageId],
//                 true,
//                 true,
//                 globalSettings?.labels?.delete?.[languageId],
//                 true,
//                 processButton,
//             ).result,
//         ]

//         //#endregion data get

//         response.result = localData;
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: supplierProcessButtonsGetAsync<br/>`;
//         response.msgText += `Sub method: ${subMethod}<br/>`;
//         response.msgText += `Error: ${ex?.message}`;
//         response.result = [];
//     }
//     return response;
// }